import { border, motion } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";

export const menuTheme = themed({
    borderRadius: {
        "lodestar-light": border.radius10,
        "ursa-light": border.radius30,
    },
    fontSize: {
        "lodestar-light": "inherit",
        "ursa-light": "14px",
    },
    optionHeight: {
        // Ursa uses 38px for both normal and compact menu items.
        normal: {
            "lodestar-light": 40,
            "ursa-light": 38,
        },
        compact: {
            "lodestar-light": 32,
            "ursa-light": 38,
        },
        dense: {
            "lodestar-light": 32,
            "ursa-light": 32,
        },
    },
    separatorHeight: {
        "lodestar-light": 24,
        "ursa-light": 24,
    },
    fontColor: {
        default: {
            rest: {
                "lodestar-light": color("color--text--neutral--default"),
                "ursa-light": color("color--text--neutral--strong"),
            },
            focus: color("color--text--neutral--strong"),
            hover: color("color--text--neutral--strong"),
            disabled: color("color--text--neutral--strong"),
        },
        // this sucks but given the shape of default.rest we have to do this for now
        primary: {
            rest: color("color--text--primary--default"),
            focus: color("color--text--primary--default"),
            hover: color("color--text--primary--default"),
            disabled: color("color--text--primary--default"),
        },
        destructive: {
            rest: color("color--text--destructive--default"),
            focus: color("color--text--destructive--default"),
            hover: color("color--text--destructive--default"),
            disabled: color("color--text--destructive--default"),
        },
    },
    boxShadow: color("elevation--default"),
    backgroundColor: {
        rest: color("color--background--surfaces--work"),

        default: {
            focus: {
                "lodestar-light": color("color--background--neutral--weak"),
                "ursa-light": color("color--background--neutral--weaker"),
            },
            pressed: {
                "lodestar-light": color("color--background--neutral--weak"),
                "ursa-light": color("color--background--neutral--default"),
            },
            hover: {
                "lodestar-light": color("color--background--neutral--weak"),
                "ursa-light": color("color--background--neutral--weakest"),
            },
        },
        primary: {
            focus: color("color--background--primary--weakest"),
            pressed: color("color--background--primary--weaker"),
            hover: color("color--background--primary--weakest"),
        },
        destructive: {
            focus: color("color--background--destructive--weakest"),
            pressed: color("color--background--destructive--weaker"),
            hover: color("color--background--destructive--weakest"),
        },
    },
    hasContentLeftPadding: "28px",
    motion: {
        itemBackground: {
            "lodestar-light": "",
            "ursa-light": `background-color ${motion.animation.default}`,
        },
        animation: {
            "lodestar-light": "",
            "ursa-light": motion.animation.default,
        },
    },
    focusContentAfterStyles: {
        default: color("color--background--primary--default"),
        primary: color("color--background--primary--default"),
        destructive: color("color--background--destructive--default"),
    },
});
